var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-01"},[_c('v-doughnut-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}}),_vm._v(" "),_c('p',{staticClass:"mb-0 text-center",domProps:{"textContent":_vm._s(_vm.data[0]+'%')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }